import { KeyboardEvent } from 'react'

/**
 * Handler que faz Enter avançar pro próximo campo focável dentro do mesmo container,
 * em vez de submeter form. Em <textarea> e em botões, mantém o comportamento padrão.
 *
 * Uso: <div onKeyDown={enterAdvance}> ... </div>
 */
export function enterAdvance(e: KeyboardEvent<HTMLElement>) {
  if (e.key !== 'Enter') return
  const target = e.target as HTMLElement
  const tag = target.tagName
  if (tag === 'TEXTAREA' || tag === 'BUTTON') return
  if (target.getAttribute('type') === 'submit') return

  const container = e.currentTarget
  const focaveis = Array.from(
    container.querySelectorAll<HTMLElement>(
      'input:not([disabled]):not([type=hidden]), select:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])'
    )
  ).filter(el => el.offsetParent !== null) // visíveis

  const i = focaveis.indexOf(target)
  if (i === -1) return

  e.preventDefault()
  const proximo = focaveis[i + 1]
  if (proximo) {
    proximo.focus()
    if (proximo instanceof HTMLInputElement) proximo.select?.()
  }
}
